<template>
  <div class="rounded bg-gray-100 p-4 md:w-1/2 mx-auto text-center">
    <h1 class="font-bold text-2xl mb-4">עדכון פורטל היוגה</h1>
    <div v-if="isDone">
      <start-build
        v-on:build-error="getBuildError"
        v-on:build-started="startNewBuild"
      ></start-build>
      <div class="bg-green-400 p-4 rounded">
        <p class="text-lg">
          עדכון מוצלח אחרון ב - {{ endTime.toLocaleString("he-il") }}
        </p>
      </div>
    </div>
    <div v-else>
      <div v-if="inProgress">
        <in-progress
          v-on:build-error="getBuildError"
          v-on:build-done="updateLog"
        ></in-progress>
      </div>
    </div>
    <div v-if="isError">
      <div class="p-4 rounded bg-red-400">
        <p class="text-lg font-bold">
          עדכון אחרון נכשל ב - {{ startTime.toLocaleString("he-il") }}
        </p>
        <p v-for="(err, index) in errors" :key="index">{{ err }}</p>
      </div>
      <start-build
        v-on:build-error="getBuildError"
        v-on:build-started="startNewBuild"
      ></start-build>
    </div>
  </div>
</template>

<script>
import getStatus from "../utils/getStatus";
import InProgress from "./inProgress.vue";
import StartBuild from "./startBuild.vue";

export default {
  components: {
    InProgress,
    StartBuild,
  },
  data() {
    return {
      log: [],
      errors: [],
      isError: false,
      isDone: false,
      inProgress: false,
    };
  },
  computed: {
    startTime() {
      if (this.log.length > 1) {
        return new Date(Number(this.log[1] + "000"));
      }
      return new Date();
    },
    endTime() {
      if (this.isDone) {
        return new Date(Number(this.log[9] + "000"));
      }
      return 0;
    },
    buildTime() {
      if (this.isDone) {
        return Number(this.log[9]) - Number(this.log[1]);
      }
      return 0;
    },
  },
  methods: {
    checkIsDone() {
      if (
        this.log.length === 10 &&
        typeof parseInt(this.log[9]) === "number" &&
        this.log[5].match("Done in")
      ) {
        this.isDone = true;
      } else {
        this.isDone = false;
      }
    },
    checkInProgress() {
      if (this.errors.length === 0 && !this.isDone) {
        const start = Number(this.log[1] + "000");
        const now = Date.parse(new Date());
        if (now - start < 600000) {
          this.inProgress = true;
        } else {
          this.getBuildError("build time exceeded limit");
        }
      } else {
        this.inProgress = false;
      }
    },
    getBuildError(e) {
      this.isError = true;
      this.errors.push(e);
      this.inProgress = false;
      this.isDone = false;
    },
    startNewBuild() {
      this.isDone = false;
      this.inProgress = true;
      this.isError = false;
      this.errors = [];
    },
    updateLog(e) {
      this.log = e;
    },
  },
  watch: {
    log() {
      this.checkIsDone();
      this.checkInProgress();
    },
  },
  async mounted() {
    const log = await getStatus();
    if (log) {
      this.log = log;
      this.checkIsDone();
      this.checkInProgress();
    } else {
      this.getBuildError("Cannot get status");
    }
  },
};
</script>
